
const venues = [
    {
        id: "rx",
        displayName: "RX Istanbul",
        aliases: ["rx", "rx istanbul", "rx nightclub"],
        city: "İstanbul",
        oneLine: "Efsane, ev, karanlık, techno'nun mabedi.",
        bio: "RX bir gece kulübü değil, bir evdi. İstanbul techno sahnesinin kalbi burada atardı. Karanlık odası, ortadaki kolondaki lazerler, function one ses sistemi, tuvalet ve vestiyer sırası... Her köşesinde bir anı vardır. Kapanması  bir devrin sonu gibidir. Prime zamanları (2020-2023) unutulmaz.",
        tags: ["Underground", "Techno", "Efsane", "Karanlık"]
    },
    {
        id: "74hall",
        displayName: "74 Hall",
        aliases: ["74", "74 hall", "74hall", "seventy four hall"],
        city: "İstanbul",
        oneLine: "Yeni kale, sert soundlar, endüstriyel vibe.",
        bio: "RX sonrası boşluğu dolduran, sert çocukların mekanı. Pashex ve ekibinin kalesi. Endüstriyel tasarımı, dumanı ve ışıklarıyla hard techno'nun yeni adresi.",
        tags: ["Hard Techno", "Industrial", "Yeni Nesil"]
    },
    {
        id: "klein_phonix",
        displayName: "Klein Phönix",
        aliases: ["klein", "klein phönix", "klein phonix", "phonix"],
        city: "İstanbul",
        oneLine: "Görkemli, büyük prodüksiyon, görsel şov.",
        bio: "İstanbul'un en büyük techno mekanlarından. Maslak tarafında. Büyük sahneler, dev led ekranlar, görsel şovlar... Daha 'piyasa' ama kaliteli işler gelir. Kalabalığı ve enerjisi başkadır.",
        tags: ["Big Room", "Visual Show", "Event Hall"]
    },
    {
        id: "klein_harbiye",
        displayName: "Klein Harbiye",
        aliases: ["klein harbiye", "harbiye klein", "eski klein"],
        city: "İstanbul",
        oneLine: "Efsanevi Harbiye atmosferi, nostaljik ve şık.",
        bio: "Klein efsanesinin en köklü lokasyonlarından. Harbiye'nin o mistik ve şık havası. Kaan Çorlu (Kaysee)'nin rekor kırdığı ve 'Nacht' serilerinin yapıldığı yer. Hikayesi olan bir mekan.",
        tags: ["Nostaljik", "Şık", "Melodic"]
    },
    {
        id: "sumahan",
        displayName: "Sumahan",
        aliases: ["suma", "sumahan", "suma han"],
        city: "İstanbul",
        oneLine: "Underground ruhun kalesi, Karaköy/Şişhane hattı.",
        bio: "İstanbul underground kültürünün en önemli kalelerinden. Eski fabrikadan bozma o salaş ve gerçekçi havası... Cumartesi geceleri sabahlanır. Müdavimi boldur, herkes birbirini tanır.",
        tags: ["Underground", "Old School", "Karaköy"]
    },
    {
        id: "kastel",
        displayName: "Kastel",
        aliases: ["kastel", "kastel teras", "minipax"],
        city: "İstanbul",
        oneLine: "Beyoğlu'nun kalesi, Hüseyin abinin mekanı.",
        bio: "Taksim/Beyoğlu hattının vazgeçilmezi. Terası ayrı, içi ayrı dünyadır. Hüseyin abi faktörü vardır. Sabaha kadar dans edilir, after için de durak olabilir. Samimi ve kaotiktir.",
        tags: ["Beyoğlu", "Teras", "Samimi"]
    },
    {
        id: "module",
        displayName: "Module",
        aliases: ["module", "modül"],
        city: "İstanbul",
        oneLine: "After mekanı, sabahçı kahvesi, bitmeyen geceler.",
        bio: "Gecenin bittiği sanılan yerde Module başlar. After mekanı denince akla ilk gelen yerlerden. Güneş doğduktan sonra bile karanlık techno devam eder. Kitlesi çok karışıktır, her çeşit insanı görebilirsin. Dayanıklılık testidir.",
        tags: ["After", "Sabahçı", "Hardcore"]
    },
    {
        id: "frankie",
        displayName: "Frankie",
        aliases: ["frankie", "frankie istanbul"],
        city: "İstanbul",
        oneLine: "Eskiden after öncesi ısınılan, klas mekan.",
        bio: "Eskiden aftera kalmadan veya geceye başlamadan önce gidilen, daha 'classy' bir mekan. Galataport/Nişantaşı tarafları. Müzikleri daha soft/melodic olabilir.",
        tags: ["Lounge", "Classy", "Melodic"]
    },
    {
        id: "suma_beach",
        displayName: "Suma Beach",
        aliases: ["suma beach", "suma plaj", "magic forest"],
        city: "İstanbul",
        oneLine: "Yazlık efsane, orman ve plaj, Magic Forest.",
        bio: "İstanbul'da yazın ve rave denince akla gelen ilk yer. Kilyos tarafı. Magic Forest'ta sabahlamak bir ritüeldir. Orman içinde techno dinlemek... Unutulmaz festivallere ev sahipliği yapar.",
        tags: ["Festival", "Open Air", "Summer"]
    },
    {
        id: "volkswagen_arena",
        displayName: "Volkswagen Arena",
        aliases: ["vw arena", "volkswagen arena", "arena"],
        city: "İstanbul",
        oneLine: "Devasa konserler, festival havası, akustik.",
        bio: "İstanbul'un en iyi akustiğine sahip kapalı etkinlik alanlarından biri. Büyük DJ'ler (Charlotte de Witte, Boris Brejcha vb.) buraya gelir. Festival havasında geçer. Giriş kuyruğu ve vestiyer savaşı dahil pakete dahildir.",
        tags: ["Concert Hall", "Big Events", "Akustik"]
    },
    {
        id: "generic_club",
        displayName: "Herhangi bir Club",
        aliases: ["mekan", "club", "kulüp", "party", "parti"],
        city: "Genel",
        oneLine: "Dans edilen, kopulan herhangi bir yer.",
        bio: "Mekan fark etmez, önemli olan sound ve yanındaki dostlar. Amaç kopmak.",
        tags: ["Genel"]
    }
];

export default venues;
